import Diff from '../../../../../../lib/diff/diff'

(() => {
  angular
    .module('app')
    .controller(
      'common.views.inpatientTickets.detail.auditHistory.compareUtilizationModal',
      CompareUtilizationModalController
    );

  CompareUtilizationModalController.$inject = [
    '$filter',
    '$uibModalInstance',
    'auditlogs',
    'moment',
  ];

  function CompareUtilizationModalController($filter, $uibModalInstance, auditlogs, moment) {
    const vm = this;

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.auditlogs = auditlogs;
    vm.differences = {};
    let diffs = [];

    vm.getModalTitle = getModalTitle;
    vm.close = close;

    init();

    function init() {
      if (vm.auditlogs.length !== 2) {
        $uibModalInstance.close();
      }

      mergeAuditlogs();
    }

    function getModalTitle() {
      return App.localize(
        'ComparisonBetweenXAndY',
        moment(vm.auditlogs[0].creationTime).format('L LT'),
        moment(vm.auditlogs[1].creationTime).format('L LT')
      );
    }

    function mergeAuditlogs() {
      const diff = {
        item: {},
        adjustments: {},
      };
      diffs = [];

      vm.auditlogs = _.sortBy(auditlogs, [(o) => o.creationTime]);

      // Construct diff.

      let idx = 0;
      _.forIn(vm.auditlogs, (al) => {
        generateDiffs(al, diff.item, idx);
        generateDiffsAdjustments(al.adjustments, diff.adjustments, idx);

        idx += 1;
      });

      // Trigger differences check.

      _.forEach(diffs, (v) => {
        v.checkDifference(vm.auditlogs.length);
      });

      vm.differences = diff;
    }

    function generateDiffs(items, diff, idx) {
      const d = diff;
      _.forIn(items, (value, key) => {
        if (value === null || value === undefined) {
          return;
        }

        // Only process the following properties for comparison.

        if (key === 'relatedPatientTicket' || key === 'remarks') {
          // Capitalize key for localisation.

          const Key = _.upperFirst(key);

          // Insert unique key in diff.

          const newDiff = new Diff(Key);
          diffs.push(newDiff);
          if (!d[Key]) d[Key] = newDiff;

          // Populate dummy.

          while (d[Key].data.length < idx) {
            d[Key].push('', true);
          }

          // Insert actual value.

          d[Key].push(value);
        }
      });
    }

    function generateDiffsAdjustments(items, diff, idx) {
      const d = diff;
      _.forEach(items, (item) => {
        const { amount } = item;
        const label = item.adjustmentServiceTypeText;

        // Insert unique key in diff.

        const newDiff = new Diff(label);
        diffs.push(newDiff);
        if (!d[label]) d[label] = newDiff;

        // Populate dummy.

        while (d[label].data.length < idx) {
          d[label].push('', true);
        }

        // Insert actual value.

        const amountText = $filter('currencyFormat')(amount, vm.currencyCode);

        d[label].push(amountText);
      });
    }

    function close() {
      $uibModalInstance.close();
    }
  }
})();
